// extracted by mini-css-extract-plugin
export var cell = "_78-4";
export var headerCell = "_78-2";
export var rowHeader = "_78-3";
export var table = "_78-1";
export var tableContainer = "_78-0";